export default __webpack_public_path__ + "static/media/icon512.796e13bb.png";